import regexps from '../constants/regexps';

const extractTitle = (html) => {
  const result = html.match(regexps.TITLE);

  return result && result[1];
};

export default extractTitle;
